import { Button, List, ListItem, Typography } from '@mui/material'
import { BoxOrderContext } from 'contexts/BoxOrderContextProvider'
import React, { useContext } from 'react'

const PickRack = () => {
  const { setSelectedClass, racks, setSelectedRack } =
    useContext(BoxOrderContext)

  return (
    <>
      {racks.length > 0 && (
        <>
          <Button
            variant='outlined'
            onClick={() => {
              setSelectedClass(null)
            }}
            sx={{
              margin: '20px'
            }}
          >
            Back
          </Button>
          <Typography variant='h3' sx={{ textAlign: 'center' }}>
            Pick a Rack
          </Typography>
          <List
            sx={{
              '& .MuiListItemButton-root': {
                color: '#607998',
                fontFamily: 'sans-serif',
                fontWeight: 600
              },
              '& a': {
                textDecoration: 'none'
              }
            }}
          >
            {racks.map(rackItem => (
              <ListItem key={rackItem.rack}>
                <Button
                  variant='contained'
                  sx={{
                    width: '100%',
                    textAlign: 'center',
                    textTransform: 'none',
                    fontSize: '26px',
                    padding: '50px 20px',
                    backgroundColor: '#364c63',
                    marginBottom: '20px'
                  }}
                  onClick={() => {
                    setSelectedRack(rackItem.rack)
                  }}
                >
                  {rackItem.rack}
                </Button>
              </ListItem>
            ))}
          </List>
        </>
      )}
    </>
  )
}

export default PickRack
